















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { ModuleOption, InformationCodes } from '@/data/enums'
import GlassOption from '@/data/glass-option'
import GlassOptionValue from '@/data/glass-option-value'
import OptionModule from '@/components/OptionModule.vue'
import Loader from '@/components/ui/Loader.vue'
import '@/icons/options-antireflection'

@Component({
  components: {
    OptionModule,
    Loader
  }
})
export default class SunCoatingModule extends Vue {
  private informationCode: string = InformationCodes.ModuleCoating
  private optionId: ModuleOption = ModuleOption.Suncoating
  private isLoading: boolean = true

  private get showPrice (): boolean {
    return this.$store.state.data.optician.showPrices
  }
  private get background (): string {
    const currentItem = this.$store.state.cart.currentItem
    let coating = '_uncoated'
    let glassType = 'multi'
    if (currentItem && currentItem.type) {
      if (currentItem.glasses.isMulti) {
        glassType = 'multi'
      } else if (currentItem.glasses.isSingle) {
        glassType = 'multi'
      } else if (currentItem.glasses.screenGlasses) {
        glassType = 'multi'
      }
      glassType += (currentItem.glasses.sunglasses) ? 'sun' : ''
      const coatingOption = currentItem.type.options.find((option: GlassOption) =>
        option.optionId === this.optionId)
      if (coatingOption) {
        const selectedValue = coatingOption.values
          .find((optionValue: GlassOptionValue) =>
            (optionValue.selected && !optionValue.isExtra))
        if (selectedValue) {
          coating = `_${selectedValue.number}`
        }
      }
    }
    return `module/suncoating/${this.$store.getters['matrix/gender']}_${glassType}${coating}.png`
  }

  private get overlay (): string {
    const currentItem = this.$store.state.cart.currentItem
    let coating = '_uncoated'
    let glassType = 'multi'
    if (currentItem && currentItem.type) {
      if (currentItem.glasses.isMulti) {
        glassType = 'multi'
      } else if (currentItem.glasses.isSingle) {
        glassType = 'multi'
      } else if (currentItem.glasses.screenGlasses) {
        glassType = 'multi'
      }
      glassType += (currentItem.glasses.sunglasses) ? 'sun' : ''
      const coatingOption = currentItem.type.options.find((option: GlassOption) =>
        option.optionId === this.optionId)
      if (coatingOption) {
        const selectedValue = coatingOption.values
          .find((optionValue: GlassOptionValue) =>
            (optionValue.selected && !optionValue.isExtra))
        if (selectedValue) {
          coating = `${selectedValue.number}`
        }
      }
    }
    return `module/suncoating/text_${coating}.png`
  }

  @Watch('background')
  private onBackgroundChanged (val: string, oldVal: string) {
    this.isLoading = true
  }

  private get optionIds (): ModuleOption[] {
    return [this.optionId]
  }

  private onLoaded () {
    this.isLoading = false
  }

  private get enabled (): boolean {
    const currentItem = this.$store.state.cart.currentItem
    if (currentItem && currentItem.type) {
      const coatingOption = currentItem.type.options.find((option: GlassOption) =>
        option.optionId === this.optionId)
      if (coatingOption) {
        const extraValue = coatingOption.values.find((optionValue: GlassOptionValue) =>
          (optionValue.isExtra === 1))
        const selectedValue = coatingOption.values.find((optionValue: GlassOptionValue) =>
          (optionValue.selected && optionValue.isExtra !== 1))
        if (selectedValue) {
          if (selectedValue.hasExtra === 1) {
            return true
          } else {
            if (extraValue) {
              extraValue.selected = false
            }
            return false
          }
        }
      }
    }
    return false
  }

  private get priceTypeText () {
    return this.$store.state.data.optician.priceTypeText
  }

  private toggleOptionValue (optionValue: GlassOptionValue) {
    this.$store.dispatch('cart/toggleOptionValue', optionValue)
      .catch((err) => console.error(err))
  }
}
